import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { MenuitemPage } from 'src/app/lessons/modals/menuitem/menuitem.page';

const routes: Routes = [
  {
    path: '',
    component: MenuitemPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [MenuitemPage]
})
export class MenuitemPageModule { }
